// Vendors
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import {
  SESSION_TIMEOUT_EMPTY_STATUS_PROPS,
  SESSION_TIMEOUT_BUTTON_PROPS,
} from './constants/session-expire-timeout.constants';
// Components
import { EmptyStatusComponent } from '@openbank/ziniaweb-ui-components';
// Styles
import { SessionExpireTimeoutComponentStyled } from './session-expire-timeout.component.styled';
// Translations
import {
  BACK_TO_MERCHANT,
  DESCRIPTION,
  TITLE,
} from './translations/session-expire-timeout.translations';
// Utils
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';

const SessionExpireTimeoutComponent = (): ReactNode => (
  <SessionExpireTimeoutComponentStyled>
    <EmptyStatusComponent
      {...SESSION_TIMEOUT_EMPTY_STATUS_PROPS}
      description={<FormattedMessage id={DESCRIPTION} />}
      mainButton={{
        ...SESSION_TIMEOUT_BUTTON_PROPS,
        children: <FormattedMessage id={BACK_TO_MERCHANT} />,
        onClick: () => navigateToCallbackUrl(),
      }}
      title={<FormattedMessage id={TITLE} />}
    />
  </SessionExpireTimeoutComponentStyled>
);

export { SessionExpireTimeoutComponent };
